import { NgClass } from '@angular/common';
import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { DeviceLastCommandStatus } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'grid-engine-last-command-status-cell',
  templateUrl: './last-command-status-cell.component.html',
  imports: [NgClass, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./last-command-status-cell.component.scss']
})
export class LastCommandStatusCellComponent implements ICellRendererAngularComp {
  params: WritableSignal<ICellRendererParams> = signal(null);
  DeviceLastCommandStatus = DeviceLastCommandStatus;

  agInit(params: ICellRendererParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
